import {Container} from 'react-bootstrap'
// import Sidebar from '../components/Agents/Sidebar'
import { Outlet } from 'react-router-dom';
import DashboardHeader from '../components/Header/DashboardHeader';
import Footer from '../components/Footer';
import { OrgProvider } from '../context/org';
import { AgentProvider } from '../context/agent';
import { Helmet } from 'react-helmet-async';

function Dashboard() {
	
    return (
        <Container>
			<Helmet>
				<title>Dashboard - QuickyChat</title>
				<meta name="description" content="Dashboard page for QuickyChat application" />
				<meta name="keywords" content="dashboard, quickychat, chat application" />
			</Helmet>
			<OrgProvider>
				<AgentProvider>
				<DashboardHeader/>
					<Container fluid className='main-content p-0'>
						<Outlet/> {/* child componenets goes here... */}
					</Container>
					<Footer/>
				</AgentProvider>
			</OrgProvider>
        </Container>
    )
}

export default Dashboard